<template>
  <div class="home">
    <Validate></Validate>
  </div>
</template>

<script>
import Validate from '@/components/Validate';

export default {
  name: 'Home',
  components: {
    Validate,
  },
};
</script>
